import worker from 'workerize-loader!./websocket.worker'
import priceWorker from 'workerize-loader!./priceWebsocket.worker'

let workerInstance = null
export const getWorker = () => {
  if (!workerInstance) {
    workerInstance = worker()
  }
  return workerInstance
}

const webSocketWorkerEvent = getWorker()
const webSocketWorkerPriceEvent = priceWorker()

export { webSocketWorkerEvent, webSocketWorkerPriceEvent }
